import { createSelector } from "reselect";

const basesSelector = (state) => state.bases;

export const getBases = createSelector([basesSelector], (state) => state.list);
